import { render, staticRenderFns } from "./NextReviewerModal.vue?vue&type=template&id=22dcdcd3&scoped=true&"
import script from "./NextReviewerModal.vue?vue&type=script&lang=js&"
export * from "./NextReviewerModal.vue?vue&type=script&lang=js&"
import style0 from "./NextReviewerModal.vue?vue&type=style&index=0&id=22dcdcd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcdcd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22dcdcd3')) {
      api.createRecord('22dcdcd3', component.options)
    } else {
      api.reload('22dcdcd3', component.options)
    }
    module.hot.accept("./NextReviewerModal.vue?vue&type=template&id=22dcdcd3&scoped=true&", function () {
      api.rerender('22dcdcd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Modal/NextReviewerModal.vue"
export default component.exports